import { useParams, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useInsightsData, BlogPost } from "../hooks/useInsightsData";

export default function BlogContentsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useInsightsData();

  const blogPostsdata = data.blogPosts.find((p: BlogPost) => p.id === id);

  if (!blogPostsdata) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
          <button
            onClick={() => navigate("/insights")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to Insights
          </button>
        </div>
      </div>
    );
  }
  return (
    <section className="pt-20 pb-10">
      {/* Close Button */}
      <div className="absolute top-0 right-16 z-50">
        <button onClick={() => navigate("/insights")}>
          <X
            className="absolute top-8 w-12 h-12 text-white rounded-full flex items-center justify-center transition-all duration-300"
            size={24}
          />
        </button>
      </div>
      <img
        className="w-full h-[500px] mb-10 object-cover"
        src={blogPostsdata?.image}
        alt="hero-image"
      />
      <section className="px-6 md:px-14">
        <div>
          <h1 className="text-3xl md:text-6xl font-bold">
            {blogPostsdata.title}
          </h1>
          {Array.isArray(blogPostsdata.fullDescription) ? (
            <div className="py-10">
              {blogPostsdata.fullDescription.map((desc, index) => (
                <p key={index} className="text-xl font-medium leading-relaxed py-2">
                  {desc}
                </p>
              ))}
            </div>
          ) : (
            <p className="text-xl font-medium leading-relaxed py-10">
              {blogPostsdata.fullDescription || blogPostsdata.readMore}
            </p>
          )}
        </div>
      </section>
    </section>
  );
}
